import React from 'react';
import { CoachAvailabilityInterval } from 'coaching/CoachingConstants';
import { findValidTimeSelectOptions, parseMidnightEndTime } from 'coaching/lib/timeIntervals';
import Button from 'components/ButtonDeprecated';
import EventTracking from 'lib/EventTracking';
import Icon from 'components/Icon';
import Row from 'components/Row';
import Select from 'components/Select';
import Text from 'components/Text';

type Props = {
  interval: CoachAvailabilityInterval;
  index: number;
  eventPrefix?: string;
  onUpdateIntervalStartTime: (newStartTime: string, endTime: string, index: number) => void;
  onUpdateIntervalEndTime: (startTime: string, newEndTime: string, index: number) => void;
  onRemoveInterval: (index: number) => void;
};

export default function TimeInputRow({
  interval,
  index,
  eventPrefix,
  onUpdateIntervalStartTime,
  onUpdateIntervalEndTime,
  onRemoveInterval,
}: Props) {
  function maybeTrackEvent(event: string) {
    if (eventPrefix) {
      EventTracking.trackKey(`${eventPrefix}.${event}`);
    }
  }
  const parsedInterval = parseMidnightEndTime(interval);
  const { validStartTimeOptions, validEndTimeOptions } = findValidTimeSelectOptions(parsedInterval);
  return (
    <Row data-test="time-input-row" size="xsmall" key={`${parsedInterval.startTime}-${index}`}>
      <table className="CoachingIsolatedView-timePicker">
        <tbody>
          <tr>
            <td>
              <Select
                data-test={`time-input-row-start-time-${index}`}
                searchable={false}
                inline
                full
                options={validStartTimeOptions}
                value={parsedInterval.startTime}
                onChange={(newStartTime: string) => {
                  onUpdateIntervalStartTime(newStartTime, parsedInterval.endTime, index);
                  maybeTrackEvent('select_start_time.click');
                }}
              />
            </td>
            <td className="CoachingIsolatedView-timePicker-text">
              <Text align="center" element="div">
                to
              </Text>
            </td>
            <td>
              <Select
                data-test={`time-input-row-end-time-${index}`}
                searchable={false}
                inline
                full
                options={validEndTimeOptions}
                value={parsedInterval.endTime}
                onChange={(newEndTime: string) => {
                  onUpdateIntervalEndTime(parsedInterval.startTime, newEndTime, index);
                  maybeTrackEvent('select_end_time.click');
                }}
              />
            </td>
            <td className="CoachingIsolatedView-timePicker-close">
              <Text align="right" element="div">
                <Button
                  level="icon"
                  onClick={() => {
                    onRemoveInterval(index);
                    maybeTrackEvent('remove_hours.click');
                  }}
                  data-test="remove-interval-button"
                  color="chalkboard">
                  <Icon name="x" size="small" altText="Remove hours" />
                </Button>
              </Text>
            </td>
          </tr>
        </tbody>
      </table>
    </Row>
  );
}
